'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.getMsaFromPath = getMsaFromPath;

var _sagaTools = require('@classpass/saga-tools');

var _effects = require('redux-saga/effects');

var _bound = require('redux/saga/entities/bound');

var _msaAliasToId = require('dynamic-data/msa-alias-to-id');

var _msas = require('redux/saga/selectors/msas');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(getMsaFromPath);

function getMsaFromPath(client, path) {
  var msaAliases, msasList, parts, msaAlias;
  return _regenerator2.default.wrap(function getMsaFromPath$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          msaAliases = (0, _msaAliasToId.getMsaAliasToId)();
          _context.next = 3;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.msas, [client]);

        case 3:
          msasList = _context.sent;
          parts = (path || '').split('/');
          msaAlias = parts.find(function (part) {
            return part in msaAliases;
          });
          return _context.abrupt('return', (0, _msas.msaByAlias)(msasList, msaAlias));

        case 7:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}